import ProjectProposalsTab from './ProjectProposalsTab';
export default ProjectProposalsTab;